import React from "react";
import { Link } from "react-router-dom";
import { RiArrowRightSLine } from "@remixicon/react";

// Mobile-app style click-through rows (icon, label, hint, chevron) used by the
// Bids / Controls / Help hub pages.
export default function LinkList({ items }) {
	return (
		<div className="card">
			{items.map((l) => (
				<Link key={l.label} to={l.to} state={l.state} className="settings-link">
					<span className="settings-link-icon">
						<l.icon size={18} />
					</span>
					<span className="flex-grow-1 min-w-0">
						<span className="d-block fw-semibold">{l.label}</span>
						{l.text ? <span className="d-block text-muted small">{l.text}</span> : null}
					</span>
					{l.badge ? <span className="link-badge">{l.badge}</span> : null}
					<RiArrowRightSLine size={18} className="text-muted" />
				</Link>
			))}
		</div>
	);
}
